import React from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { useOrigen } from '../../contexts/OrigenContext';
export function OrigenToggle() {
  const {
    active,
    toggle
  } = useOrigen();
  return <button type="button" onClick={toggle} aria-pressed={active} className={`fixed bottom-[88px] left-5 z-[1000] inline-flex items-center gap-2 rounded-pill px-4 py-[10px] font-sans text-[13px] font-semibold text-white shadow-[0_4px_16px_rgba(27,58,92,0.4)] transition-colors duration-200 md:bottom-6 md:left-6 ${active ? 'bg-secondary hover:bg-[#2f9a95]' : 'bg-primary hover:bg-[#16304c]'}`} data-id="element-216" data-mp="1q843bmbpdqg7">
      {active ? <EyeOffIcon className="h-4 w-4" data-id="element-217" data-mp="17gtdz9lmllqf" /> : <EyeIcon className="h-4 w-4" data-id="element-218" data-mp="1c8kussezcd3d" />}
      {active ? 'Ocultar notas' : 'Ver criterio estratégico'}
    </button>;
}